import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import NotificationsPopup from "../common/NotificationsPopup";
import ImpersonationSiteComponent from "./ImpersonationBySite.jsx";
import ImpersonationSearchComponent from "./ImpersonationBySearch.jsx";
import Header from "../common/Header.jsx";
import { getSuperUserLinks } from "../../actions/UrlActions";

export class SuperUserPage extends Component {
    constructor (props) {
        super(props);

        this.state = {
            isShowOnlyAdmins: false
        };
    }

    componentDidMount() {
        import('./_styles.scss');
        this.props.getSuperUserLinks();
    }

    showCentralManagementUrl (url) {
        return (
            <li key={"UserManagement"} className="list-group-item">
                <a href={url.UserManagement}>Central Management</a>
            </li>);
    }

    showQuantifiUrls (url) {
        return (
            <li key={"QuantifiImporter" } className="list-group-item">
                <a href={url.QuantifiImporter}>Quantifi Importer</a>
            </li>
        );
    }

    render () {
        const superUserToolUrls = this.props.superUserToolUrls;

        if (this.props.redirectTo && this.props.redirectTo != "") {
            if(this.props.openInNewWindow){
                window.open(this.props.redirectTo, "_sisenseWindow");
            } 
            else {
                window.location = this.props.redirectTo;
            }
        }
        return (
            <div id="superUserPage">
                <Header/>
                <div id="row" className="outerContainer">
                    <h2 title="User Impersonation!!!!">Site Login</h2>
                    <div className="col-md-8 divider">
                        <div className="col-md-5 divider">
                            <h3>Search By Site Id</h3>
                            <ImpersonationSiteComponent/>
                        </div>
                        <div className="col-md-7">
                            <h3>Search By Site Name</h3>
                            <ImpersonationSearchComponent/>
                        </div>
                    </div>
                    <div className="col-md-4" />

                    <div className="row">

                        <div className="col-md-12">
                            <h2>Site Administration</h2>
                            <ul id="linksList" className="adminLinks offset list-group">
                                { this.showCentralManagementUrl(superUserToolUrls) }
                                { this.showQuantifiUrls(superUserToolUrls) }
                            </ul>
                        </div>
                    </div>
                </div>
                <NotificationsPopup />
            </div>
        );
    }
}

SuperUserPage.defaultProps = {
    superUserToolUrls: [],
    getSuperUserLinks: () => {}
};

SuperUserPage.propTypes = {
    superUserToolUrls: PropTypes.array,
    getSuperUserLinks: PropTypes.func,
    openInNewWindow: PropTypes.bool,
};

const mapStateToProps = state => ({
    superUserToolUrls: state.appState.superUserToolUrls,
    redirectTo: state.appState.redirectTo,
    openInNewWindow: state.appState.openInNewWindow,
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getSuperUserLinks: () => dispatch(getSuperUserLinks())
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperUserPage);
